// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"145817d6","372":"d597c4f4","408":"e319da3c"}[chunkId] + ".chunk.js";
};